<!--
 * @Author: your name
 * @Date: 2020-03-13 16:31:00
 * @LastEditTime: 2023-10-17 23:26:49
 * @LastEditors: yjf531 yjf531@126.com
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Apply.vue
 -->
<template>
  <div class="BaomingSuccess">
       <img class="sub-logo2" src="../assets/baomingLogo.png">
        <div class="content2">
                <div class="top2">
                    <img src="../assets/baomingTop.png" class="topImg">
                </div>
                <div class="registered2">
                    <div class="qrcode2">
                        <img src="../assets/qcode3.png" class="qrcodeImg">
                    </div>
                    <div class="tip">
                        <!-- <img src="../assets/baomingTip.png" class="tipImg"> -->
                        <!-- <div class="tip-title2">报名时间已截止</div>
                        <div class="tip-content">本次会议您无法参加</div>
                        <div class="tip-content">期待您下次参加</div>
                        <div class="tip-content">请长按上方图片</div>
                        <div class="tip-content">识别小程序二维码</div>
                        <div class="tip-content">平台内有丰富的学习内容</div>
                        <div class="tip-content">本次会议回看也将于12月1日上线</div>
                        <div class="tip-content">感谢您的关注</div> -->
                        <div class="tip-content">感谢您的报名，本次会议将于11月1日下午2点同步直播上线，敬请扫描二维码登录小程序收看！</div>
                        <!-- <div class="tip-content">请于2020年11月23日下午13:30准时进入该小程序参加直播会议</div> -->
                    </div>
                </div>
                <div class="bottom">
                        <img src="../assets/baomingBottom.png" class="bottomImg">
                    </div>
            </div>
            <van-popup v-model="show"> <img :src="qrcode" class="qrcodeImg2"></van-popup>
  <share></share>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: 'BaomingSuccess',
  data() {
    return {
      qrcode: "http://wsl-cdn.medmeet.com.cn/1603700858520",
      meetid: 1001, // 会议ID
      show: false,
    };
  },

  methods: {
    // 获取二维码
    getRrcode() {
        let data = {}
        data.meetid = this.meetid
        data.type = 1
        Http.post(api.getQrcode, data).then((response) => {
            this.qrcode = response.data.thumb
        });
        return false;
    },
    showPopup() {
      this.show = true
    },

    onClose() {
      this.show = false
    },
  },
  mounted: function() {
    document.title = '报名系统'
    this.getRrcode()
  },
};
</script>

<style lang="less" scoped>
.BaomingSuccess {
  font-size: 16px;
    display: flex;
    flex-direction: column;
     background-color: #041d34;
      min-height: 100vh;
     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        left: 20px;    
    }
  .content2 {
    // position: relative;
    //  min-height: 100vh;
      display: flex;
    flex-direction: column;
    .top2 {
         margin: 52px auto 0;
         width: 80%;
         text-align: center;
        .topImg {
            width: 80%;
        }
    }
    .registered2 {
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 20px;
        width: 90%;
        margin: auto;
      .qrcode2 {
          margin: 0 auto;
          width: 40%;
          .qrcodeImg {
              width: 100%;
          }
      }
      .tip {
          margin: 0 auto;
          text-align: center;
          color: #1dbbec;
          width: 100%; 
      //   font-size: 22px;
          .tip-title2 {
            font-size: 14px;
          }
          .tip-content {
            font-size: 14px;
          }
      }
    }

      .bottom {
          margin-top: 12px;
          // position: absolute;
          // bottom: 0px;
          .bottomImg {
              width: 100%;
          }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaomingSuccess.vue